<template>
  <v-card
    class="pt-3 pb-3"
    outlined
    dark
    color="#0E2D58"
    :height="height"
    :max-height="maxHeight"
    :max-width="maxWidth"
    :min-height="minHeight"
    :min-width="minWidth"
  >
    <v-list-item
      two-line
      :style="{'text-align': align}"
    >
      <v-list-item-content>
        <v-list-item-title style="font-size: 40px;line-height: 36px">
          {{ title }}
        </v-list-item-title>
        <v-list-item-subtitle style="font-size: 14px; line-height: 21px; white-space: normal !important;">
          {{ subTitle }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-card>
</template>

<script>
  export default {
    name: "InfoCard",
    props: {
      title: {
        type: [String, Number],
        default: ""
      },
      subTitle: {
        type: [String, Number],
        default: ""
      },
      align: {
        type: String,
        default: 'center'
      },
      height: {
        type: [String, Number],
        default: '120px'
      },
      maxHeight: {
        type: [String, Number],
        default: ""
      },
      maxWidth: {
        type: [String, Number],
        default: ""
      },
      minHeight: {
        type: [String, Number],
        default: ""
      },
      minWidth: {
        type: [String, Number],
        default: ""
      },
    }
  }
</script>

<style scoped>
</style>: